<template>
  <!-- Auth -->
  <div v-if="me.data.id" class="" id="wrapper">
 <!-- SIDEBAR -->
    <Sidebar @sidebar-toggle="handleSidebarToggle" />
    <!-- SIDEBAR -->

    <!-- MAIN CONTENT -->
    <div id="page-content-wrapper" class="w-100">
      <!-- NAVBAR -->

      <!-- NAVBAR -->

      <!-- MAIN CONTENT(ROUTER VIEW) -->
      <div class="mx-4" :style="{ marginTop: $route.name === 'Chat' ? '0px' : '80px' }">

        <!-- <AlertConfirmEmail v-if="me.data.id > 1"/> -->
        <!-- <AlertSystemTester v-if="isTester() && me.data.role_key > 0"/> -->
        <AlertSystemUsage />
        <!-- Breadcrumbs -->
        <!-- <transition name="view">
          <Breadcrumb/>
        </transition> -->

        <!-- LOADER -->
        <!-- <transition name="view" v-if="configs.loading || chat.getting_tickets">
          <Loader />
        </transition> -->
       <transition name="fade" v-if="$route.name === 'Chat' && chat.getting_tickets && !chat.first_load_completed">
            <div style="position: relative;">
              <LoaderMessages />
            </div>
        </transition>

        <!-- Loader genérico para todas as outras rotas -->
        <transition name="view" v-else-if="configs.loading">
          <Loader />
        </transition>




        <!-- Main Content -->
        <div v-show="!configs.loading && !chat.getting_tickets">
          <transition name="view">
            <Breadcrumb />
          </transition>

          <transition name="view">
            <div v-if="configs && me" class="container-fluid" style="margin-bottom: 20px">
              <router-view/>
            </div>
          </transition>
        </div>

        <!-- Modals -->
        <Modals />

        <!-- Voip -->
        <WidgetVoIP />

        <!-- Conversation window-->
        <!--<ConversationWindow v-if="me.data.id > 1 && !($mq === 'mobile' || $mq === 'tablet')"/>-->

        <!-- Audio for notification alert -->
        <audio v-show="false" id="audio" ref="audio">
          <source src="songs/notification.ogg" type="audio/ogg" />
          <source src="songs/notification.mp3" type="audio/mpeg" />
          <source src="songs/notification.wav" type="audio/x-wav" />
        </audio>
      </div>
      <!-- MAIN CONTENT(ROUTER VIEW) -->
    </div>
    <!-- MAIN CONTENT -->
    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>

import Pusher from 'pusher-js';
import Navbar from "../components/theme/Navbar";
import Breadcrumb from "../components/general/Breadcrumb";
import { mapActions, mapGetters, mapState } from "vuex";
import Footer from "../components/theme/Footer";
import Modals from "../components/general/Modals";
import WidgetVoIP from "../components/voip/WidgetVoIP";
import Loader from "../components/general/Loader";
import AlertConfirmEmail from "../components/general/AlertConfirmEmail";
import iziToast from "izitoast";
import lead_avatar from "../assets/img/no-pic-user.png";
import Push from 'push.js';
import MenuMobile from "../components/theme/MenuMobile";
import AlertSystemUsage from "../components/general/AlertSystemUsage";
import ConversationWindow from "../components/conversation/ConversationWindow";
import AlertSystemTester from "../components/general/AlertSystemTester";
import Swal from 'sweetalert2';
import logo_beecrm_white_blue from '../../../public/images/logo_beecrm_new_colors.png'
import notifications from '../store/modules/notifications';
import Pagination from '../components/theme/Pagination.vue';
import flag_br from "../assets/images/flags/br.svg"
import flag_es from "../assets/images/flags/es.svg"
import flag_us from "../assets/images/flags/us.svg"
import "../../../resources/js/assets/css/Theme.css"
import Sidebar from '../components/theme/Sidebar.vue';
import { UilWhatsapp, UilQuestionCircle, UilCommentDots } from '@iconscout/vue-unicons';
import { SidebarClose as SidebarCloseIcon, SidebarOpen as SidebarOpenIcon, LayoutDashboard, 
  MessageCircle, 
  KanbanSquare, 
  Image as ImageIcon,
  CheckSquare, 
  Users, 
  Megaphone, 
  BarChart3, 
 Rss, 
  User, 
  Settings  } from "lucide-vue";

import LoaderMessages from '../components/general/LoaderMessages.vue';
export default {
  name: "Theme",
  components: {
  LayoutDashboard,
  MessageCircle,
  KanbanSquare,
  ImageIcon,
  CheckSquare,
  Users,
  Megaphone,
  BarChart3,
  Rss,
   Sidebar,
  User,
  Settings,
    SidebarCloseIcon,
    SidebarOpenIcon,
    AlertSystemTester,
    ConversationWindow,
    AlertSystemUsage,
    MenuMobile,
    AlertConfirmEmail,
    WidgetVoIP,
    Modals,
    Footer,
    Breadcrumb,
    Navbar,
    Loader,
    LoaderMessages,
    UilWhatsapp,
    UilCommentDots,
    UilQuestionCircle,
    Pagination,
  },
  computed: {
    ...mapState([
      'me',
      'operators',
      'campaigns',
      'configs',
      'chat',
      'tickets',
      'histories',
      'leads',
      'lead_tags',
      'users',
      'replies',
      'notifications',
      'motives',
      'interests',
      'funnels',
      'tags',
      'tasks',
      'channels',
      'departments',
      'sources',
      
    ]),
    notificationsData: state => state.notifications.pagination || {},
    userInfo() {
      return this.me.data || {};  // retorna o usuario logado
    },
    ...mapGetters([
      'getSidebarOptions',
      'getChannelObject',
      'getTicketObject',
      'getLeadObject'
    ]),

    unreadNotificationsCount() {
      return this.notifications.pagination.data && Array.isArray(this.notifications.pagination.data)
        ? this.notifications.pagination.data.filter(
          (notification) => notification.status_key === 0
        ).length
        : 0;
        
    },
    hasUnreadNotifications() {
    return (
      Array.isArray(this.notificationsData.data) &&
      this.notificationsData.data.some(n => n.status_key === 0)
    );
  },
  },
  data() {
    return {
      lastTicketsCountUpdate: 0,
      tooltip: {
        text: "",
        show: false,
        style: {}
      },
      showUserPopover: false,
      showHelpPopover: false,
      logo_beecrm_white_blue: logo_beecrm_white_blue,
      notification: null,
      lead_avatar: lead_avatar,
      timer_confirm_presence: null,
      timer_disconnect_user: null,
      user_confirm_presence: false,
      showing_alert_to_confirm_presence: false,
      isDropdownOpen: false,
      flag_br: flag_br,
      flag_es: flag_es,
      flag_us: flag_us,
    }
  },
  beforeDestroy() {
    window.document.removeEventListener('click', this.closeSideBar)
    document.removeEventListener('click', this.handleClickOutside)
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    window.document.addEventListener('click', this.closeSideBar)
    setTimeout(() => {
      this.showAlertToDisconnect()
    }, 1000 * 60 * 180);
    // setInterval(this.setUserOnline(), 1000 * 60 * 5);
    setInterval(() => {
      if (this.me.data && this.me.data.id) {
        this.$store.dispatch('updateUserOnline', { id: this.me.data.id, online: true });
      }
    }, 1000 * 60 * 5);
    // }, 5000);
    this.configs.current_url = document.URL.split('://')[1].split('/')[0];

    let current_url_array = this.configs.current_url.split('.')
    current_url_array.shift();
    this.configs.domain = current_url_array.toString().replace(/,/g, '.');

    this.loadResources();
  },
  watch: {},
  methods: {
    ...mapActions(['logoutUser']),
// mostra a opção apenas para domínios .beecrm.io e alguns específicos de teste
 getIconComponent(iconName) {
    const icons = {
      'layout-dashboard': LayoutDashboard,
      'message-circle': MessageCircle,
      'kanban-square': KanbanSquare,
      'image': ImageIcon,
      'check-square': CheckSquare,
      'users': Users,
      'megaphone': Megaphone,
      'bar-chart-3': BarChart3,
      'rss': Rss,
      'user': User,
      'settings': Settings
    };
    return icons[iconName] || LayoutDashboard;  // fallback de segurança
  },
showOnlyInBeecrmOrAllowedHosts() {
  const hostname = window.location.hostname;

  const allowedExactHosts = [
    'testemeta.beelabs.com.br',
    'teste1.bee.local:9000',
    'teste1.bee.local',
    'beelabs3.beelabs.localhost'
  ];

  return (
    allowedExactHosts.includes(hostname) ||
    hostname.endsWith('.beecrm.io') ||
    hostname === 'beecrm.io'
 
  );
},

// mostra a opção apenas para ambientes de teste (oculta em todos os outros)
showOnlyInAllowedTestHosts() {
      return ['testemeta.beelabs.com.br',
        'teste1.bee.local:9000',
        'teste1.bee.local',
        'beelabs3.beelabs.localhost'].includes(window.location.hostname)
    },

// Oculta opcao para dominios



    showTooltip(text, event) {
      const icon = event.target.getBoundingClientRect();
      this.tooltip.text = this.getTranslations(text) || text;
      this.tooltip.show = true;
      this.tooltip.style = {
        top: `${icon.top + window.scrollY + icon.height / 2 - 18}px`, // ajuste vertical
        left: `${icon.right + 20}px` // ajuste horizontal
      };
      this.tooltip.styleClass = 'primary';
    },

    hideTooltip() {
      this.tooltip.show = false;
    }
    ,
    toggleUserPopover() {
      this.showUserPopover = !this.showUserPopover;
      if (this.showUserPopover) {
        this.showHelpPopover = false;
        this.$nextTick(() => {
          this.updatePopoverPosition('user');
        });
      }
    },

    toggleHelpPopover() {
      this.showHelpPopover = !this.showHelpPopover;
      if (this.showHelpPopover) {
        this.showUserPopover = false;
        this.$nextTick(() => {
          this.updatePopoverPosition('help');
        });
      }
    },
    updatePopoverPosition(popoverType) {
      const button = popoverType === 'user' ? this.$refs.userProfileRef : this.$refs.helpButtonRef;
      if (button && button.getBoundingClientRect) {
        const rect = button.getBoundingClientRect();
        const popover = this.$el.querySelector(popoverType === 'user' ? '.user-popover' : '.help-popover');

        // if (popover) {
        //   // Ajusta a posição vertical para alinhar com o botão
        //   popover.style.top = `${rect.top - 580}px`;

        //   // Não precisamos definir left aqui, pois está sendo controlado pelo CSS
        //   // com base na classe sidebar-open ou sidebar-closed
        // }
      }
    },
    openSubMenu(option) {
      option.sub_menu_open = !option.sub_menu_open;
      let menu_options = document.getElementById('sidebar-menu-options');
      setTimeout(() => {
        menu_options.scrollTo({
          top: menu_options.scrollHeight,
          behavior: 'smooth',
        })
      }, 300)
    },
  handleSidebarToggle() {
      this.configs.sidebar_open = !this.configs.sidebar_open;
    },
    closeSidebar() {
      this.configs.sidebar_options.forEach(option => {
        if (option.sub_menu_open) {
          option.sub_menu_open = false;
        }
      })
      this.configs.sidebar_open = false
    }, toggleSidebar() {
      this.configs.sidebar_open = !this.configs.sidebar_open;
    },
    toggleLanguageDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    handleClickOutside(event) {
      const container = this.$el;
      if (container && !container.contains(event.target)) {
        this.isDropdownOpen = false;
      }
      if (
        this.showHelpPopover &&
        this.$refs.helpPopoverRef &&
        !this.$refs.helpPopoverRef.contains(event.target) &&
        !this.$refs.helpButtonRef.contains(event.target)
      ) {
        this.showHelpPopover = false;
      }
      if (
        this.showUserPopover &&
        this.$refs.userPopoverRef &&
        !this.$refs.userPopoverRef.contains(event.target) &&
        !this.$refs.userProfileRef.contains(event.target)
      ) {
        this.showUserPopover = false;
      }
    },
    getCurrentLanguageFlag() {
      const currentLangId = this.me.data.language_key;
      if (currentLangId === 0 || currentLangId === '0') return this.flag_br;
      if (currentLangId === 1 || currentLangId === '1') return this.flag_us;
      return this.flag_es;
    },
    getCurrentLanguageName() {
      const currentLangId = this.me.data.language_key;
      const lang = this.configs.data.user_languages.find(
        l => l.id === (typeof currentLangId === 'string' ? parseInt(currentLangId) : currentLangId)
      );
      return lang ? lang.description : 'Português';
    },
    isCurrentLanguage(langId) {
      const currentLangId = this.me.data.language_key;
      return (currentLangId === langId) ||
        (typeof currentLangId === 'string' && parseInt(currentLangId) === langId);
    },
    // Using the original setLanguage method
    setLanguage(lang) {
      this.isDropdownOpen = false;
      const routeCurrent = this.$route.name;

      this.$store.dispatch('updateUser', {
        id: this.me.data.id,
        channel_id: this.dashboard.channel_id,
        language_key: lang === 0 ? '0' : lang
      }).then(() => {
        return this.$store.dispatch('getReloadLang', {
          channel_id: this.dashboard.channel_id
        });
      }).then(() => {
        if (this.$route.name !== 'Lead') {
          return this.$store.dispatch('getTickets', {
            status_key: [0, 1, 2, 3, 4, 5],
            channel_id: this.dashboard.channel_id,
            per_page: 10
          });
        }
      }).then(() => {
        // Ignora erro de "Navegação duplicada" quando tenta acessar a mesma rota
        this.$router.push({ name: routeCurrent }).catch(error => {
          if (error.name !== "NavigationDuplicated") {
            throw error;
          }
        });
      })
    },


    showNotification(payload) {
      if (payload.status_key === 0) {
        this.$store.dispatch('updateNotification', {
          id: payload.id,
          status_key: 1,
        });
        payload.status_key = 1;
      }
      this.$store.commit('SET_NOTIFICATION', payload);
    },

    showAlertToDisconnect() {
      this.showing_alert_to_confirm_presence = true;
      this.user_confirm_presence = false;
      setTimeout(() => {
        this.disconnectUser()
      }, 1000 * 60 * 30);

      Swal.fire({
        title: this.getTranslations('expression_208').replace(':operator_name', this.me.data.name),
        text: this.getTranslations('expression_209'),
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.getTranslations('expression_210'),
        allowOutsideClick: false
      }).then(() => {
        this.initNewTimer()
      })
    },
    disconnectUser() {
      if (!this.user_confirm_presence && this.showing_alert_to_confirm_presence) {
        this.$store.dispatch('logoutUser');
      }
    },
    initNewTimer() {
      this.showing_alert_to_confirm_presence = false;
      this.user_confirm_presence = true;
      setTimeout(() => {
        this.showAlertToDisconnect()
      }, 1000 * 60 * 180);
    },
    updateUser(payload) {
      this.$store.dispatch('updateUser', payload)
    },
    async loadResources() {
      this.notifyMe();

      await this.$store.dispatch('startLoading');
      await this.$store.dispatch("getMe");
      await this.loadingLoop();
    },
    async loadingLoop() {
      if (this.me.data && this.me.data.id) {
        await this.getSocket();
        // Verifica idioma no localstorage
        if (!window.localStorage.getItem("temp_lang") ||
          window.localStorage.getItem("temp_lang") === undefined ||
          window.localStorage.getItem("temp_lang") === null) {

          // Seta no LS a preferência de acordo com o usuário logado
          window.localStorage.setItem("temp_lang", this.me.data.language_key)
          this.$store.commit("SET_ME_LANG", window.localStorage.getItem("temp_lang"))

        } else if (window.localStorage.getItem("temp_lang")) {
          const routeCurrent = this.$route.name;
          if (parseInt(window.localStorage.getItem("temp_lang")) !== parseInt(this.me.data.language_key)) {
            this.$store.dispatch('updateUserOnline', {
              id: this.me.data.id,
              language_key: window.localStorage.getItem("temp_lang")
            })
            this.$store.commit("SET_ME_LANG", window.localStorage.getItem("temp_lang"))
            // this.$store.dispatch('getReloadLang', {channel_id: this.dashboard.channel_id})
            if (this.$route.name !== 'Lead') {
              this.$store.dispatch('getTickets', {
                status_key: [0, 1, 2, 3, 4, 5, 11],
                channel_id: this.dashboard.channel_id,
                per_page: 10
              })
            }
            // Ignora erro de "Navegação duplicada" quando tenta acessar a mesma rota, mas exibe outros erros que possam ocorrer.
            this.$router.push({ name: routeCurrent }).catch(error => {
              if (error.name !== "NavigationDuplicated") {
                throw error;
              }
            });
          }
        }
      } else {
        setTimeout(async () => {
          await this.loadingLoop();
        }, 500);
      }
    },
    async getSocket() {
      if (this.configs.data.base_url !== undefined && this.channels.data.length > 0) {
        window.Pusher = new Pusher('soketi', {
          wsHost: window.location.hostname,
          wsPort: window.location.port,
          wssPort: window.location.port,
          cluster: 'mt1',
          forceTLS: window.app_env === 'production',
          encrypted: true,
          disableStats: true,
          enabledTransports: ['ws', 'wss'],
        });

        window.Pusher.subscribe(`global.${this.configs.data.base_url}`);

        this.channels.data.forEach(channel => {
          window.Pusher.subscribe(`${channel.id}.${this.configs.data.base_url}`);
        });

        window.Pusher.bind('campaign', payload => {
          const campaign_from_socket = payload.data;

          if (this.campaigns.pagination.per_page) {
            if (this.campaigns.board_view_enabled) {
              const campaignKey = this.campaigns.pagination.data.findIndex(campaignData => {
                return campaignData.id == campaign_from_socket.id
              })
              if (campaignKey > -1) {
                this.campaigns.data.splice(campaignKey, 1, campaign_from_socket);
              } else {
                if(this.campaigns.pagination.current_page == 1) {
                  let user_id_empty = ['', null, 0].includes(this.campaigns.fields_search.user_id);
                  let channel_id_empty = ['', null, 0].includes(this.campaigns.fields_search.channel_id);
                  let user_id_equal = this.campaigns.fields_search.user_id == campaign_from_socket.user_id
                  let channel_id_equal = this.campaigns.fields_search.channel_id == campaign_from_socket.channel_id

                  if ((user_id_empty || user_id_equal) && (channel_id_empty || channel_id_equal)) {
                    if(!this.campaigns.data[0] || campaign_from_socket.id > this.campaigns.data[0].id) {
                      if(this.campaigns.data.length <= 7) {
                        this.campaigns.data.unshift(campaign_from_socket)
                      } else {
                        this.campaigns.data.pop()
                        this.campaigns.data.unshift(campaign_from_socket)
                      }
                    }
                  }
                }
              }
              // this.$store.dispatch("getCampaigns", this.campaigns.fields_search);
            }

            // const campaignKey = this.campaigns.pagination.data.findIndex(campaignData => {
            //   return campaignData.id == campaign_from_socket.id
            // })
            // if (campaignKey > -1) {
            //   if (this.campaigns.fields_search.channel_id == campaign_from_socket.channel_id) {
            //     if (!['', null, 0].includes(this.campaigns.fields_search.user_id)) {
            //       if (this.campaigns.fields_search.user_id == campaign_from_socket.user_id) {
            //         this.$store.dispatch("getCampaigns", this.campaigns.fields_search);
            //       }
            //     } else {
            //       this.$store.dispatch("getCampaigns", this.campaigns.fields_search);
            //     }
            //   }
            // }
            // else {
            //   if (this.campaigns.pagination.current_page == 1) {
            //     if (campaign_from_socket.deleted_at == null) {
            //       if (this.campaigns.pagination.data.length < 8) {
            //         // if(!['', null, 0].includes(this.campaigns.fields_search.channel_id)) {
            //         if (this.campaigns.board_view_enabled) {
            //           if (this.campaigns.fields_search.channel_id == campaign_from_socket.channel_id) {
            //             if (!['', null, 0].includes(this.campaigns.fields_search.user_id)) {
            //               if (this.campaigns.fields_search.user_id == campaign_from_socket.user_id) {
            //                 this.$store.dispatch("getCampaigns", this.campaigns.fields_search);
            //               }
            //             } else {
            //               this.$store.dispatch("getCampaigns", this.campaigns.fields_search);
            //             }
            //           }
            //         }
            //       }
            //     }
            //   }
            // }
          }
        });

        window.Pusher.bind('channel', payload => {
          const channel = payload.data;
          const channelKey = this.channels.data.findIndex(channelData => {
            return channelData.id === channel.id
          })
          if (channelKey > -1) {
            this.channels.data.splice(channelKey, 1)
          }
          if (channel.deleted_at === null || !channel.deleted_at) {
            this.channels.data.push(channel)
          }
          if (channel.id === this.channels.channel.id && channel.integrations[9].status_key && channel.integrations[9].data.token) {
            this.channels.channel.integrations[9].status_key = channel.integrations[9].status_key;
            this.channels.channel.integrations[9].data.token = channel.integrations[9].data.token;
          }
        });

        // VIDE CONVERSATIONWINDOW
        window.Pusher.bind('conversation', payload => {
          const conversation = payload.data;
          this.$root.$emit('setConversation', conversation)
        });

        // VIDE TAB_TELEGRAM // TAB_WHATSAPP
        window.Pusher.bind('isChannelState', payload => {
          const state = payload.data;
          this.$root.$emit('isChannelState', state)
        });

        window.Pusher.bind('department', payload => {
          const department = payload.data;

          const departmentKey = this.departments.data.findIndex(departmentData => {
            return departmentData.id === department.id
          })
          if (departmentKey > -1) {
            this.departments.data.splice(departmentKey, 1)
          }
          if (department.deleted_at === null || !department.deleted_at) {
            this.departments.data.push(department)
          }
        });

        window.Pusher.bind('funnel', payload => {
          const funnel = payload.data;
          const funnelKey = this.funnels.data.findIndex(funnelData => {
            return funnelData.id === funnel.id
          })
          if (funnelKey > -1) {
            this.funnels.data.splice(funnelKey, 1)
          }
          if (funnel.deleted_at === null) {
            this.funnels.data.push(funnel)
          }
        });

        window.Pusher.bind('update_status_history', payload => {
          const history_from_socket = payload.data

          // MENSAGENS DO TICKET QUE ESTÁ ABERTO ATUALMENTE NO CHAT
          if (this.chat.ticket.channel_id == history_from_socket.channel_id) {
            const historyKeyOfTicketInChat = this.chat.histories_current_ticket.findIndex(item => {
              return item.remote_id == history_from_socket.remote_id
            })
            if (historyKeyOfTicketInChat > -1) {
              this.chat.histories_current_ticket[historyKeyOfTicketInChat].status = history_from_socket.status;
              this.chat.histories_current_ticket[historyKeyOfTicketInChat].status_key = history_from_socket.status_key;
            }
          }

          // MODAL COM MENSAGENS TICKET QUE FOI ABERTO ATRAVÉS DO DASHBOARD OU RELATÓRIO DE TICKETS
          if (this.tickets.ticket.channel_id == history_from_socket.channel_id) {
            const historyKeyOfTicketFollowup = this.tickets.histories_followup_ticket.findIndex(item => {
              return item.remote_id == history_from_socket.remote_id
            })
            if (historyKeyOfTicketFollowup > -1) {
              this.chat.histories_current_ticket[historyKeyOfTicketFollowup].status = history_from_socket.status;
              this.chat.histories_current_ticket[historyKeyOfTicketFollowup].status_key = history_from_socket.status_key;
            }
          }
        })

        window.Pusher.bind('history', payload => {
          const history = payload.data;

          const ticketKey = this.chat.tickets.findIndex(ticket => ticket.id === history.ticket_id);
          if (ticketKey > -1) {
            this.chat.tickets[ticketKey].latest_history_text = history.text;
            if (!history.updating_status) {
              this.chat.tickets[ticketKey].latest_history_created_at = history.created_at;
              this.chat.tickets[ticketKey].latest_history_created = history.created;
            }
            // this.chat.tickets[ticketKey].not_read = this.chat.tickets[ticketKey].not_read + 1;
          }
          if (this.chat.ticket.id == history.ticket_id) {
            const historyKeyOfTicketInChat = this.chat.histories_current_ticket.findIndex(item => {
              return item.id === history.id
            })
            if (historyKeyOfTicketInChat > -1) {
              this.chat.histories_current_ticket.splice(historyKeyOfTicketInChat, 1)
            }
            this.chat.histories_current_ticket.push(history);
            // this.$store.dispatch('hookActive');
            setTimeout(() => {
              document.getElementById('chat_conversation').scrollIntoView({ block: "end", behavior: "smooth" });
            }, 200);
          }

          if (this.tickets.ticket.id == history.ticket_id) {
            const historyKeyOfTicketFollowup = this.tickets.histories_followup_ticket.findIndex(item => {
              return item.id === history.id
            })
            if (historyKeyOfTicketFollowup > -1) {
              this.tickets.histories_followup_ticket.splice(historyKeyOfTicketFollowup, 1)
            }
            this.tickets.histories_followup_ticket.push(history);
            setTimeout(() => {
              document.getElementById('chat_conversation2').scrollIntoView({ block: "end", behavior: "smooth" });
            }, 200);
          }

          // Teste de Notificação Toast
          if (history.origin_key === 0 && this.$route.name !== 'Chat') {
            if (this.getOperatorsArray('user_id', this.me.data.id).length > 0) {
              if
                (
                this.isOperator(this.getTicketObject('id', history.ticket_id)) > 0
                && this.isOperator(this.getTicketObject('id', history.ticket_id)
                  === this.getTicketObject('id', history.ticket_id).operator_id
                ) ||
                (
                  this.isOperator(this.getTicketObject('id', history.ticket_id)) > 0
                  && this.getTicketObject('id', history.ticket_id).operator_id === null
                ) ||
                (
                  this.isOperator(this.getTicketObject('id', history.ticket_id)) > 0
                  && !this.getTicketObject('id', history.ticket_id).operator_id
                )
              ) {
                if ([0, 2, 3, 4].includes(this.getTicketObject('id', history.ticket_id).status_key)) {
                  if (this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone !== undefined) {
                    setTimeout(() => {
                      Push.create(`${this.getTranslations('expression_1111')}`, {
                        body: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone}`,
                        // icon: 'https://i.imgur.com/fOAA1j8.png',
                        icon: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
                        timeout: 20000,
                        tag: `message-ticket-${history.ticket_id}`,
                        vibrate: [200, 100],
                        onClick: function () {
                          window.focus();
                          this.close();
                        }
                      });
                      iziToast.show({
                        id: `message-ticket-${history.ticket_id}`,
                        title: `${this.getTranslations('expression_1111')}`,
                        message: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).name} <br> <i class='bx bxs-phone'></i> ${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone}`,
                        image: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
                        layout: 2,
                        theme: 'light',
                        maxWidth: 400,
                        imageWidth: 100,
                        backgroundColor: '#fff',
                        displayMode: 'once',
                        drag: true,
                        progressBar: false,
                        buttons: [
                          ['<button>' + this.getTranslations('expression_1110') + '</button>', (instance, toast) => {
                            instance.hide({
                              transitionOut: 'fadeOutUp',
                              onClosing: () => {
                                setTimeout(() => {
                                  this.show_ticket(this.getTicketObject('id', history.ticket_id))
                                  $("#showTicketModal").modal("show");
                                }, 100);
                              }
                            }, toast);
                          }]
                        ],
                      });
                    }, 500);
                  }
                }
              }
            } else {
              if (this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone !== undefined) {
                setTimeout(() => {
                  Push.create(`${this.getTranslations('expression_1111')}`, {
                    body: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone}`,
                    // icon: 'https://i.imgur.com/fOAA1j8.png',
                    icon: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
                    timeout: 20000,
                    tag: `message-ticket-${history.ticket_id}`,
                    vibrate: [200, 100],
                    onClick: function () {
                      window.focus();
                      this.close();
                    }
                  });
                  iziToast.show({
                    id: `message-ticket-${history.ticket_id}`,
                    title: `${this.getTranslations('expression_1111')}`,
                    message: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).name} <br> <i class='bx bxs-phone'></i> ${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).phone}`,
                    image: `${this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
                    layout: 2,
                    theme: 'light',
                    maxWidth: 400,
                    imageWidth: 100,
                    backgroundColor: '#fff',
                    displayMode: 'once',
                    drag: true,
                    progressBar: false,
                    buttons: [
                      ['<button>' + this.getTranslations('expression_1110') + '</button>', (instance, toast) => {
                        instance.hide({
                          transitionOut: 'fadeOutUp',
                          onClosing: () => {
                            setTimeout(() => {
                              this.show_ticket(this.getTicketObject('id', history.ticket_id))
                              $("#showTicketModal").modal("show");
                            }, 100);
                          }
                        }, toast);
                      }]
                    ],
                  });
                }, 500);
              }
            }
          }
          if (history.origin_key === 0) {
            if (this.getOperatorsArray('user_id', this.me.data.id).length > 0) {
              setTimeout(() => {
                if ((this.isOperator(this.getChatTicketObject('id', history.ticket_id)) > 0 && this.isOperator(this.getChatTicketObject('id', history.ticket_id)) === this.getChatTicketObject('id', history.ticket_id).operator_id) || (this.isOperator(this.getChatTicketObject('id', history.ticket_id)) > 0 && this.getChatTicketObject('id', history.ticket_id).operator_id === null)) {
                  if ([0, 2, 3, 4].includes(this.getChatTicketObject('id', history.ticket_id).status_key)) {
                    // setTimeout(() => {
                    //   this.audioNotification(history);
                    // }, 500);
                    // Alerta sempre que não estiver no Chat
                    if (this.$route.name !== 'Chat' && this.$route.name !== 'ReportsTickets') {
                      this.audioNotification(history);
                    } else {
                      // Caso esteja no Chat, verifica se possui ticket ativo. Se não tiver, notifica
                      if (this.chat.ticket && !this.chat.ticket.id) {
                        this.audioNotification(history);
                      } else if (this.chat.ticket && this.chat.ticket.id) {
                        // Notifica se o novo ticket não for o mesmo que já estiver ativo
                        if (this.chat.ticket.id != history.ticket_id) {
                          this.audioNotification(history);
                        }
                      }
                    }
                  }
                }
              }, 1000)
            }
          }

          // @todo: notificar somente quando a mensagem for de um ticket listagem no chat, não ativo e quando for do cliente final ou sistema ([0, 2].includes(origin_key))
          /*if (this.notification) {
            this.notification.close()
          }
          this.notification = new Notification('Uma nova mensagem chegou!', {
            body: `Teste`,
            icon: 'https://cockpit.appbee.online/_v1/images/logo-sm-dark.png'
          });*/
        });

        window.Pusher.bind('importLead', payload => {
          const lead = payload.data;
          setTimeout(() => {
            this.leads.import_leads.step = lead.step;
            this.leads.import_leads.total = lead.total ? lead.total : 0;
            if (lead.data) {
              this.leads.import_leads.data = lead.data;
            }
          }, 1000)
        });

        window.Pusher.bind('interest', payload => {
          const interest = payload.data;
          const interestKey = this.interests.data.findIndex(interestData => {
            return interestData.id === interest.id
          })
          if (interestKey > -1) {
            this.interests.data.splice(interestKey, 1)
          }
          if (interest.deleted_at === null) {
            this.interests.data.push(interest)
          }
        });

        window.Pusher.bind('lead', payload => {
          const lead = payload.data;
          const leadKey = this.leads.data.findIndex(leadData => {
            return leadData.id === lead.id
          })
          this.$root.$emit('remainingHsm', lead);
          if (leadKey > -1) {
            this.leads.data[leadKey].name = lead.name;
            this.leads.data[leadKey].email = lead.email;
            this.leads.data[leadKey].status_key = lead.status_key;
            this.leads.data[leadKey].newsletter_key = lead.newsletter_key;
            this.leads.data[leadKey].avatar_url = lead.avatar_url;
            this.leads.data[leadKey].expiration = lead.expiration;
            this.leads.data[leadKey].expiration_at = lead.expiration_at;
            this.leads.data[leadKey].remaining = lead.remaining;
            this.leads.data[leadKey].send_history = lead.send_history;
          }
          if (this.leads.pagination.data !== undefined) {
            const leadPaginationKey = this.leads.pagination.data.findIndex(leadData => {
              return leadData.id === lead.id
            })
            if (leadPaginationKey > -1) {
              this.leads.pagination.data[leadPaginationKey].name = lead.name;
              this.leads.pagination.data[leadPaginationKey].email = lead.email;
              this.leads.pagination.data[leadPaginationKey].status_key = lead.status_key;
              this.leads.pagination.data[leadPaginationKey].newsletter_key = lead.newsletter_key;
              this.leads.pagination.data[leadPaginationKey].avatar_url = lead.avatar_url;
              this.leads.pagination.data[leadPaginationKey].expiration = lead.expiration;
              this.leads.pagination.data[leadPaginationKey].expiration_at = lead.expiration_at;
              this.leads.pagination.data[leadPaginationKey].remaining = lead.remaining;
              this.leads.pagination.data[leadPaginationKey].send_history = lead.send_history;
            }
          }
        });

        window.Pusher.bind('leadTag', payload => {
          const leadTag = payload.data;
          const leadTagKey = this.lead_tags.data.findIndex(lead_tag => {
            return lead_tag.id === leadTag.id
          })
          if (leadTagKey > -1) {
            this.lead_tags.data.splice(leadTagKey, 1)
          }
          // if (leadTag.deleted_at === null) {
          //   this.lead_tags.data.push(leadTag)
          // }
          if (!leadTag.deleted_at) {
            this.lead_tags.data.push(leadTag)
          }
        });

        window.Pusher.bind('logoutUserWorld', payload => {
          const socket = payload.data;
          if (socket.id === this.me.data.id && this.me.data.id > 1) {
            this.logoutUser();
          }
        });

        window.Pusher.bind('motive', payload => {
          const motive = payload.data;
          const motiveKey = this.motives.data.findIndex(motiveData => {
            return motiveData.id === motive.id
          })
          if (motiveKey > -1) {
            this.motives.data.splice(motiveKey, 1)
          }
          if (motive.deleted_at === null) {
            this.motives.data.push(motive)
          }
        });

        window.Pusher.bind('notification', payload => {
          const notification = payload.data;
          if (parseInt(this.me.data.id) === parseInt(notification.user_id)) {
            this.$store.dispatch('getNotifications')
            this.$store.dispatch('getNotificationsCount')
            if (notification.status_key === 0 && notification.created_at === notification.updated_at) {
              setTimeout(() => {
                Push.create(`${notification.data.title}`, {
                  body: `${notification.data.text}`,
                  timeout: 20000,
                  tag: `message-notification-${notification.id}`,
                  vibrate: [200, 100],
                  onClick: function () {
                    window.focus();
                    this.close();
                  }
                });
                iziToast.show({
                  id: `message-notification-${notification.id}`,
                  title: `${notification.data.title}`,
                  message: `${notification.data.text}`,
                  theme: 'light',
                  maxWidth: 400,
                  imageWidth: 100,
                  backgroundColor: '#fff',
                  displayMode: 'once',
                  drag: true,
                  progressBar: false,
                });
              }, 500);
            }
          }
        });

        window.Pusher.bind('operator', payload => {
          const operator = payload.data;
          const operatorKey = this.operators.data.findIndex(operatorData => {
            return operatorData.id === operator.id
          })
          if (operatorKey > -1) {
            this.operators.data.splice(operatorKey, 1)
          }
          if (!operator.deleted_at) {
            this.operators.data.push(operator)
          }
        });

        window.Pusher.bind('reply', payload => {
          const reply = payload.data;
          const replyKey = this.replies.data.findIndex(replyData => {
            return replyData.id === reply.id
          })
          if (replyKey > -1) {
            this.replies.data.splice(replyKey, 1)
          }
          if (reply.deleted_at === null) {
            this.replies.data.push(reply)
          }
        });

        window.Pusher.bind('source', payload => {
          const source = payload.data;
          const sourceKey = this.sources.data.findIndex(sourceData => {
            return sourceData.id === source.id
          })
          if (sourceKey > -1) {
            this.sources.data.splice(sourceKey, 1)
          }
          if (source.deleted_at === null) {
            this.sources.data.push(source)
          }
        });

        window.Pusher.bind('tag', payload => {
          const tag = payload.data;
          const tagKey = this.tags.data.findIndex(tagData => {
            return tagData.id === tag.id
          })
          if (tagKey > -1) {
            this.tags.data.splice(tagKey, 1)
          }
          if (tag.deleted_at === null) {
            this.tags.data.push(tag)
          }
        });

        window.Pusher.bind('task', payload => {
          const task = payload.data;
          if (task.deleted_at === null && (task.admin_id === this.me.data.id || task.user_id === this.me.data.id)) {
            this.$store.dispatch('getCalendar', { admin_id: this.me.data.id })
          }
        });

        window.Pusher.bind('ticket', payload => {
          const ticket = payload.data;
          // console.log('Ticket do socket', ticket);

              
      const now = Date.now();
  // atualiza se passaram mais de 2 minutos
   if (ticket.status_key !== undefined && ticket.status_key !== this.previousStatusKey && now - this.lastTicketsCountUpdate > 120000) {
    this.previousStatusKey = ticket.status_key;
    this.lastTicketsCountUpdate = now;
    this.$store.dispatch('getTicketsCount', this.chat.filter_search, true);
  }

//                     const now = Date.now();

// if (ticket.status_key === undefined) return;


// const ticketsForStatus = this.getChatTicketsFilter(ticket.status_key) || [];
// const existsInList = ticketsForStatus.some(t => t.id == ticket.id);


// if (!existsInList) {
//   this.$store.dispatch('updateLocalTicketCounts', {
//     oldStatus: undefined,
//     newStatus: ticket.status_key
//   });
// }

// // atualiza se passou mais de 2 minutos
// if (ticket.status_key !== this.previousStatusKey && now - this.lastTicketsCountUpdate > 120000) {
//   this.previousStatusKey = ticket.status_key;
//   this.lastTicketsCountUpdate = now;
//   this.$store.dispatch('getTicketsCount', this.chat.filter_search, true);
// }

          // DATA (VERIFICAR REAL NECESSIDADE)
          /*const ticketDataIndex = this.tickets.data.findIndex(data => {
            return data.id === ticket.id
          })
          if (ticketDataIndex > -1) {
            this.tickets.data.splice(ticketDataIndex, 1);
          }
          if (!ticket.deleted_at) {
            this.tickets.data.unshift(ticket);
          }*/

          // TEMPO REAL DENTRO DO LEAD (VERIFICAR NECESSIDADE)
          if (this.tickets.tickets_lead.data) {
            const leadTicketKey = this.tickets.tickets_lead.data.findIndex(chat => {
              return chat.id == ticket.id
            })
            if (leadTicketKey > -1) {
              this.tickets.tickets_lead.data.splice(leadTicketKey, 1)
            }
            if (ticket.lead_id == this.leads.lead.id) {
              if (!ticket.deleted_at) {
                this.tickets.tickets_lead.data.unshift(this.xeroxHelper(ticket))
              }
            }
          }

          // Listagem de tickets (paginação)
          if (this.tickets.pagination.data) {
            const paginationTicketKey = this.tickets.pagination.data.findIndex(chat => {
              return chat.id == ticket.id
            })
            if (paginationTicketKey > -1) {
              this.tickets.pagination.data.splice(paginationTicketKey, 1)
            }
          }

          // CHAT
          const chatTicketKey = this.chat.tickets.findIndex(chat => {
            return chat.id == ticket.id
          })
          if (chatTicketKey > -1) {
            this.chat.tickets.splice(chatTicketKey, 1)
          }

          // console.log('isOperator ?', this.isOperator(ticket));
          // console.log('department_id:', ticket.department_id);
          // console.log('operator_id:', ticket.operator_id);
          if (!ticket.deleted_at || ticket.deleted_at == null) {
            // console.log('Entrou nas verificações do chat');
            if (this.tickets.ticket.id == ticket.id) {
              this.tickets.ticket = ticket
            }

            if ([0, 1, 2, 3, 4, 5, 11].includes(ticket.status_key)) {
              if (this.tickets.pagination.data) {
                if (this.getOperatorsArray('user_id', this.me.data.id).length > 0) {
                  if ([0, 2, 3, 4].includes(ticket.status_key)) {
                    // console.log('Entrou nos tickets que podem ter interação');

                    // Regra dos tickets que entram no chat
                    let isOperator = this.isOperator(ticket);
                    let ticket_operator_id = ticket.operator_id
                    if (isOperator > 0 && (isOperator === ticket_operator_id || !ticket_operator_id)) {
                      // console.log('Operador pode visualizar o ticket');

                      // if(chatTicketKey == -1 && ticket.new) {
                      //   this.chat.filter_search.status_key = 
                      //   this.chat.ticket = ticket
                      // }
                      this.$store.dispatch("getLeadsData", [{ lead_id: ticket.lead_id }]);
                      if (this.chat.ticket.id == ticket.id) {
                        if (ticket.not_read > 0) {
                          ticket.not_read = 0
                          this.$store.dispatch('updateTicketChat', {
                            id: ticket.id,
                            not_read: 0
                          })
                        }
                        this.chat.ticket = ticket
                      }
                      if ([0, 2, 3, 4].includes(ticket.status_key)) {
                        // console.log('Ticket foi incluído no array de tickets do chat');
                        this.chat.tickets.unshift(ticket)
                        // Depois
                        // this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))

                        // Antes
                        if (this.tickets.pagination.data.length == 10) {
                          this.tickets.pagination.data.pop()
                          this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
                        } else {
                          this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
                        }
                      }
                    } else {
                      if (this.chat.ticket.id == ticket.id) {
                        this.chat.ticket = {}
                      }
                    }
                  } else {
                    if (this.chat.ticket.id == ticket.id) {
                      this.chat.ticket = {}
                    }
                  }
                } else {
                  if (parseInt(this.dashboard.channel_id) > 0 && parseInt(this.dashboard.channel_id) == parseInt(ticket.channel_id)) {
                    // ANTES
                    // this.$store.dispatch("getLeadsData", [{lead_id: ticket.lead_id}]);
                    // this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))

                    // DEPOIS
                    this.$store.dispatch("getLeadsData", [{ lead_id: ticket.lead_id }]);
                    if (this.tickets.pagination.data.length == 10) {
                      this.tickets.pagination.data.pop()
                      this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
                    } else {
                      this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
                    }
                  }
                }
              }
            } else {
              if (this.chat.ticket.id == ticket.id) {
                this.chat.ticket = {}
              }
              // (VERIFICAR REAL NECESSIDADE)
              /*if (this.$route.name === 'ReportsTickets' && this.tickets.pagination.data) {
                this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
              }
              if (this.$route.name === 'Lead' && ticket.lead_id === parseInt(window.localStorage.getItem("lead_id")) && this.tickets.pagination.data) {
                this.tickets.pagination.data.unshift(this.xeroxHelper(ticket))
              }*/
            }
          }
        });

        window.Pusher.bind('user', payload => {
          const user = payload.data;
          const userKey = this.users.data.findIndex(userData => {
            return userData.id === user.id
          })
          if (userKey > -1) {
            this.users.data.splice(userKey, 1)
          }
          if (user.deleted_at === null) {
            this.users.data.push(user)
          }
          if (user.id > 1 && this.me.data.id !== user.id) {
            const conversationKey = this.conversations.data.findIndex(conversationData => {
              return conversationData.id === user.id
            })
            if (conversationKey > -1) {
              this.conversations.data.splice(conversationKey, 1)
            }

            let channel_id_includes_in_user = false;
            for (let channel_id of user.channels_id) {
              if (this.me.data.channels_id.includes(channel_id)) {
                channel_id_includes_in_user = true;
              }
            }
            if (channel_id_includes_in_user && user.deleted_at === null) {
              this.conversations.data.push(user)
              this.$root.$emit('setUserStatus', user)
            }
          }
          if (this.me.data.id === user.id) {
            this.$store.commit("SET_ME_LANG", user.language_key)
            user.language_key = parseInt(user.language_key);
            this.$store.commit('SET_ME', user)
          }
        });

        window.Pusher.bind('userOnline', payload => {
          const online = payload.data;
          if (online.id === this.me.data.id) {
            this.$store.dispatch('updateUserOnline', { id: online.id, online: true });
          }
        });

        window.Pusher.bind('userSession', payload => {
          const session = payload.data;
          if (this.me.data.id) {
            if (session.id === this.me.data.id && session.userSession !== window.localStorage.getItem('sessionUser') && session.type === 'login' && this.me.data.id > 1) {
              this.logoutUser();
            }
            if (session.id === this.me.data.id && session.userSession !== window.localStorage.getItem('sessionUser') && session.type === 'verify' && this.me.data.id > 1) {
              this.logoutUser();
            }
            if (session.id === this.me.data.id && session.type === 'logout' && this.me.data.id > 1) {
              this.logoutUser();
            }
          }
        });
      } else {
        setTimeout(() => {
          this.getSocket()
        }, 100)
      }
    },
    isOperator(ticket) {
      if (ticket.department_id === null) {
        ticket.department_id = this.getChannelObject('id', ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id == ticket.department_id && operator.user_id == this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
  notifyMe() {
  if (!("Notification" in window)) {
    console.warn("Este browser não suporta notificações de Desktop");
    return;
  }

  if (Notification.permission === "granted") {
    console.log("Notifications activated");
    return;
  }

  if (Notification.permission !== 'denied') {
    Notification.requestPermission()
      .then(permission => {
        if (permission === "granted") {
          console.log("Notifications activated");
        } else {
          console.log("User declined notification permission");
        }
      })
      .catch(error => {
        console.warn("Notification permission request failed:", error);
        // Não mostrar erro para o usuário, apenas logar
      });
  }
},
    show_ticket(payload) {
      this.tickets.ticket_view = 1;
      this.$store.commit('SET_TICKET', payload);
      this.$store.dispatch('getLeadTags', { lead_id: payload.lead_id })
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({ block: "end", behavior: "smooth" });
      }, 500);
    },
    audioNotification(history) {
      let promise = document.querySelector('#audio').play();
      if (promise !== undefined) {
        promise.then(() => {
        });
      }
      Push.create(`${this.getTranslations('expression_1111')}`, {
        body: `${this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).phone}`,
        // icon: 'https://i.imgur.com/fOAA1j8.png',
        icon: `${this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
        timeout: 20000,
        tag: `message-ticket-${history.ticket_id}`,
        vibrate: [200, 100],
        onClick: function () {
          window.focus();
          this.close();
        }
      });
      iziToast.show({
        id: `message-ticket-${history.ticket_id}`,
        title: `${this.getTranslations('expression_1111')}`,
        message: `${this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).name} <br> <i class='bx bxs-phone'></i> ${this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).phone}`,
        image: `${this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).avatar_url ? this.getLeadObject('id', this.getChatTicketObject('id', history.ticket_id).lead_id).avatar_url : lead_avatar}`,
        layout: 2,
        theme: 'light',
        maxWidth: 400,
        imageWidth: 100,
        backgroundColor: '#fff',
        displayMode: 'once',
        drag: true,
        progressBar: false,
        buttons: [
          ['<button>' + this.getTranslations('expression_1110') + '</button>', (instance, toast) => {
            instance.hide({
              transitionOut: 'fadeOutUp',
              onClosing: () => {
                setTimeout(() => {
                  this.show_ticket(this.getChatTicketObject('id', history.ticket_id))
                  $("#showTicketModal").modal("show");
                }, 100);
              }
            }, toast);
          }]
        ],
      });
    },
  }
}
</script>
